import React from "react";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { Result, Spin } from 'antd';
import moment from "moment";
import { Util } from "common/util";
import { getCostSharing, getPayrollForAgresso } from "services/payroll_report";
import withDataTable from "./withDataTable";

const pathName = "/reports/payroll/cost_sharing";
const columns = [
  {
    title: "Name",
    dataIndex: "employeeName",
    key: "employeeName"
  },
  {
    title: "EMP#",
    dataIndex: "employeeCode",
    key: "employeeCode"
  },
  {
    title: "Position",
    dataIndex: "position",
    key: "position"
  },
  {
    title: "Gross Salary",
    dataIndex: "grossSalary",
    key: "grossSalary",
    align: "right",
    render: grossSalary => grossSalary && Util.getInstance().formatCurrency(grossSalary)
  },
  {
    title: "Fringe Benefits",
    dataIndex: "totalAllowance",
    key: "totalAllowance",
    align: "right",
    render: totalAllowance => totalAllowance && Util.getInstance().formatCurrency(totalAllowance)
  },
  {
    title: "13th Month Salary",
    dataIndex: "annualSalary",
    key: "annualSalary",
    align: "right",
    render: annualSalary => annualSalary && Util.getInstance().formatCurrency(annualSalary)
  },
  {
    title: "Seniority Indemnity",
    dataIndex: "seniority",
    key: "seniority",
    align: "right",
    render: seniority => seniority && Util.getInstance().formatCurrency(seniority)
  },
  {
    title: "PF NPA Contribution",
    dataIndex: "PFOrganization",
    key: "PFOrganization",
    align: "right",
    render: (PFOrganization) => PFOrganization && Util.getInstance().formatCurrency(PFOrganization)
  },
  {
    title: "PF Staff Contribution",
    dataIndex: "PFStaff",
    key: "PFStaff",
    align: "right",
    render: PFStaff => PFStaff && Util.getInstance().formatCurrency(PFStaff)
  },
];

const handleSearch = (e) => {
  const value = e.target.value;
  const params = new URLSearchParams(document.location.search);

  if (value) {
    params.set("search", value)
  } else {
    params.delete("search");
  }

  Util.getInstance().pushParamsToURL(pathName, params.toString());
};

const getData = () => {
  let option = {};
  const params = new URLSearchParams(document.location.search);
  if (params.has("date")) option["date"] = params.get("date");
  if (params.has("search")) option["search"] = params.get("search");

  return getCostSharing(option);
};

const componentWillMount = () => {
  const params = new URLSearchParams(document.location.search);
  if (!params.get("date")) {
    params.set("date", moment().format("YYYY-MM"));
  }
  Util.getInstance().pushParamsToURL(pathName, params.toString());
};

function ExportFormLoader() {
  const [loading, setLoading] = React.useState(true);
  const [result, setResult] = React.useState(null);
  const navigate = useNavigate();
  const params = new URLSearchParams(document.location.search);

  React.useEffect(() => {

    if (params.get("payrollPeriod")) {
      let option = {};
      if (params.has("date")) option["date"] = params.get("date");
      if (params.has("payrollPeriod")) option["payrollPeriod"] = params.get("payrollPeriod");
      if (params.has("search")) option["search"] = params.get("search");

      option["isExport"] = true;
      getCostSharing(option)
        .then((response) => {
          if (response) {
            setResult(response);
          }
        }).catch(error => {
          if (error.response.status === 403) {
            localStorage.removeItem("ACCESS_TOKEN");
            navigate("/signin");
          }
        })
        .finally(() => setLoading(false));
    } else {
      let option = {};
      if (params.has("date")) option["date"] = params.get("date");
      if (params.has("type")) option["type"] = params.get("type");
      if (params.has("search")) option["search"] = params.get("search");

      option["isExport"] = true;
      getPayrollForAgresso(option)
        .then((response) => {
          if (response) {
            setResult(response);
          }
        }).catch(error => {
          if (error.response.status === 403) {
            localStorage.removeItem("ACCESS_TOKEN");
            navigate("/signin");
          }
        })
        .finally(() => setLoading(false));
    }

    return () => {
      params.delete("payrollPeriod")
      Util.getInstance().pushParamsToURL(pathName, params.toString());
    };
    // eslint-disable-next-line
  }, []);
  return (
    <>
      {loading ? (
        <Spin
          spinning={loading}
          style={{
            height: "24vh",
            display: "flex",
            alignItems: "center",
          }}
        ></Spin>
      ) : (
        <Result
          status="success"
          title="Successfully exported"
          extra={[
            <div style={{ marginBottom: 25 }}>
              <a key="1" className="ant-btn ant-btn-dashed" href={result ? result.link : "#"}>
                {t("text_download_file_xlsx")}
              </a>
            </div>
          ]}
        />
      )}
    </>
  );
}

export default withDataTable({
  title: "Payroll Report",
  subTitle: "Cost Shared",
  backLink: "/reports/payroll",
  datePlaceholder: t("text_mm_yyyy"),
  showDate: true,
  dateFormat: "MM/YYYY",
  pickerDate: "month",
  showDropdownExport: true,
  pathName,
  buttonOption: ExportFormLoader,
  customEmptyMessage: t("text_please_select_date_and_employee"),
  columns,
  componentWillMount,
  handleSearch,
  getData,
});
